import React from 'react'
import classes from "./ContactHero.module.css"

const ContactHero = () => {
  return (
    <section className={classes.contact_hero}>
        <h2 className={classes.hero_header}>Contact Me</h2>
    </section>
  )
}

export default ContactHero;